import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { ___, partialApply } from '@ipfabric/utils/fp/partialApply';
import { deselectAllNodes } from 'components/Graph/commands/deselectAllNodes';
import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { selectPathLookupApplied } from 'components/Graph/model/selectors/graphMetadata/selectPathLookupApplied';
import { selectAllEdgesSettings } from 'components/Graph/model/selectors/selectAllEdgesSettings';
import { collapseNodes } from './helpers/collapseNodes';
import { createNodeCollapsingUndoableAction } from './helpers/createNodeCollapsingUndoableAction';

export const collapseSelectedNodes: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    if (selectPathLookupApplied(cmdContext.getState())) {
      stumble('Collapsing selected nodes is not allowed for Path-lookup');
      return;
    }
    const originalGraph = cmdContext.getState().graph;
    const nodeIdsToCollapse = originalGraph.selectedNodeIds;
    dispatch(deselectAllNodes);
    dispatch(
      performUndoableAction,
      createNodeCollapsingUndoableAction(
        cmdContext.updateState,
        originalGraph,
        partialApply(
          collapseNodes,
          ___,
          selectAllEdgesSettings(cmdContext.getState()),
          nodeIdsToCollapse,
        ),
      ),
    );
  };
